<template>
  <div>
    <h4 class="mb-3 text-xl font-semibold"><slot /></h4>
  </div>
</template>
